// extracted by mini-css-extract-plugin
module.exports = {"mail-page-header":"header_mail-page-header__WQhpL"};